/** Build-time variables, supplied by `import.meta.env`. */
export type AnalyticsEnv = Pick<
  ImportMetaEnv,
  "VITE_POSTHOG_KEY" | "VITE_POSTHOG_SESSION_REPLAY" | "VITE_PRAXIS_ENVIRONMENT"
>;

/** Which project this build reports to, whether it records the screen, and its stage. */
export interface AnalyticsConfig {
  projectKey: string;
  sessionReplay: boolean;
  /** Every stage reports into the one project, so each event names its own. */
  environment: string;
}

/** What the worker calls a stage that names none, so the two sides agree. */
const UNNAMED_ENVIRONMENT = "development";

/**
 * `null` means this build reports nothing, which is the state of every
 * environment until one is deliberately given a project key.
 */
export function readAnalyticsConfig(env: AnalyticsEnv): AnalyticsConfig | null {
  const projectKey = env.VITE_POSTHOG_KEY?.trim();
  if (!projectKey) return null;

  return {
    projectKey,
    // Recording is a separate decision from reporting, and a costlier one, so
    // it takes the exact string rather than anything that reads as truthy.
    sessionReplay: env.VITE_POSTHOG_SESSION_REPLAY === "true",
    environment: env.VITE_PRAXIS_ENVIRONMENT?.trim() || UNNAMED_ENVIRONMENT,
  };
}
